import { render, staticRenderFns } from "./SourceDetails.vue?vue&type=template&id=487748a8&scoped=true"
import script from "./SourceDetails.vue?vue&type=script&lang=ts"
export * from "./SourceDetails.vue?vue&type=script&lang=ts"
import style0 from "./SourceDetails.vue?vue&type=style&index=0&id=487748a8&lang=scss"
import style1 from "./SourceDetails.vue?vue&type=style&index=1&id=487748a8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487748a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('487748a8')) {
      api.createRecord('487748a8', component.options)
    } else {
      api.reload('487748a8', component.options)
    }
    module.hot.accept("./SourceDetails.vue?vue&type=template&id=487748a8&scoped=true", function () {
      api.rerender('487748a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/sources/components/SourceDetails.vue"
export default component.exports